import Collection, { CollectionPlainObject } from '@/collection/entity/Collection';
import CutwiseAPIClient, {
  METHOD_COPY,
  METHOD_GET,
  METHOD_HEAD,
  METHOD_POST,
} from '@/common/network/CutwiseAPIClient';
import ConsoleLog from '@/common/network/middleware/ConsoleLog';
import QueryResult from '@/common/network/QueryResult';
import { ProductType } from '@/product/constants/productTypes';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';

import { getDefaultCollectionSettings } from '../helpers/getDefaultCollectionSettings';

export const PATH_COLLECTIONS = 'api/v2/collections';

export default class CollectionsAPI {
  create(productType: ProductType, title: string, description = ''): Promise<QueryResult<CollectionPlainObject>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_POST)
      .body({
        access: GlobalAccessLevel.Public,
        dataAccess: ProjectDataAccess.HideProjectSource,
        title,
        description,
        type: Collection.getTypeByProductType(productType),
        settings: getDefaultCollectionSettings(productType),
      })
      .path(PATH_COLLECTIONS);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  fetch(id: string, shouldDumpResponse = false) {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(`${PATH_COLLECTIONS}/${id}`)
      .suppressErrorNotifications();

    const query = qb.getQuery();

    if (shouldDumpResponse) {
      query.addResponseMiddleware(ConsoleLog);
    }

    return CutwiseAPIClient.sendQuery(query);
  }

  fetchOwned(type?: number): Promise<QueryResult<CollectionPlainObject[]>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(`${PATH_COLLECTIONS}/my`)
      .addQueryStringParam('type', type);

    if (type) {
      qb.addQueryStringParam('type', type);
    }

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  copy(id: string) {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_COPY).path(`${PATH_COLLECTIONS}/${id}`);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  touchCollection(c: Collection) {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_HEAD).path(`${PATH_COLLECTIONS}/${c.id}`);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
